import { IBuyPackageResponse } from '../../../repositories/billing-service-packages-balancer/v2/buy-package';
import { IBuyPackageSuccess } from '../types';
import { EBuyPackageStatus } from '../../../types';

export const mapResponse200 = (response: IBuyPackageResponse): IBuyPackageSuccess => {
  const { code } = response;

  return {
    isSuccess: true,
    code: code as string as EBuyPackageStatus,
  };
};
